module.exports = __webpack_public_path__ + "assets/img/succ7.64d9c2b5.png";